export default __webpack_public_path__ + "static/media/pakrap-3.0877bbd3.mp3";